function showOnlyOnce(data, widgetType) {
  if (
    data.openOnce === true &&
    data.turnOffCookies !== true &&
    widgetType == 'classic'
  ) {
    if (document.cookie.indexOf('wWidgetOnlyOnce') == -1) {
      document.cookie = 'wWidgetOnlyOnce=true'
    } else {
      return false
    }
  } else if (widgetType == 'classic') {
    document.cookie =
      'wWidgetOnlyOnce=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  }
  return true
}

function getHue(rgbColor) {
  let r = 0,
    g = 0,
    b = 0
  if (rgbColor === undefined) return 0
  // 3 digits
  if (rgbColor.length == 4) {
    r = '0x' + rgbColor[1] + rgbColor[1]
    g = '0x' + rgbColor[2] + rgbColor[2]
    b = '0x' + rgbColor[3] + rgbColor[3]

    // 6 digits
  } else if (rgbColor.length == 7) {
    r = '0x' + rgbColor[1] + rgbColor[2]
    g = '0x' + rgbColor[3] + rgbColor[4]
    b = '0x' + rgbColor[5] + rgbColor[6]
  }
  if (Math.abs(r - g) <= 10 && Math.abs(g - b) <= 10 && Math.abs(b - r) <= 10)
    return -1
  r /= 255
  g /= 255
  b /= 255

  // Find greatest and smallest channel values
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0
  // Calculate hue
  // No difference
  if (delta == 0) h = 0
  // Red is max
  else if (cmax == r) h = ((g - b) / delta) % 6
  // Green is max
  else if (cmax == g) h = (b - r) / delta + 2
  // Blue is max
  else h = (r - g) / delta + 4

  h = Math.round(h * 60)

  // Make negative hues positive behind 360°
  if (h < 0) h += 360
  return h
}

function padValue(value, length = 2, char = '0') {
  if (value > 99) return 99
  const { length: currentLength } = value.toString()
  if (currentLength >= length) return value.toString()
  return `${char.repeat(length - currentLength)}${value}`
}

const conf = [
  {
    id: 'Return',
    name: 'Returns',
    color: '#F2DFC4',
    icon: 'https://widget.tochat.be/faq-icons/box.png',
  },
  {
    id: 'Broken',
    name: 'Broken',
    color: '#E8B5B0',
    icon: 'https://widget.tochat.be/faq-icons/broken-heart.png',
  },
  {
    id: 'Discount',
    name: 'Returns',
    color: '#D9DBC3',
    icon: 'https://widget.tochat.be/faq-icons/money-bag.png',
  },
  {
    id: 'Delivery',
    name: 'Returns',
    color: '#D7EEF6',
    icon: 'https://widget.tochat.be/faq-icons/broken-heart.png',
  },
]

const getConf = (id) => conf.find((o) => o.id == id)

const getproperty = (id, type) => {
  const obj = getConf(id)
  if (obj && obj.hasOwnProperty(type)) {
    return obj[type]
  } else {
    return ''
  }
}

const toArray = (data) => {
  return data.split('|')
}

const getWrittenName = (data, dataObject, showPrices, currency, showDurations) => {
  if (!dataObject) {
    return data;
  }

  const price = dataObject.find(obj => obj?.value === data)?.price;
  const writtenName = dataObject.find(obj => (obj?.value === data) && (obj?.writtenName !== ''))?.writtenName;
  const duration = dataObject.find(obj => obj?.value === data)?.duration;

  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
      return `${hours}h ${remainingMinutes}m`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${remainingMinutes}m`;
    }
  };

  let result = showPrices ? `${writtenName ?? data} (${price} ${currency ?? 'USD'})` : (writtenName ?? data);
  if (showDurations && duration) {
    result += ` - ${formatDuration(duration)}`;
  }
  return result;
}

const splitNameAndPrice = (text) => {
  // Regex para detectar el nombre, precio y duración
  const regex = /^(.*?)(?:\(([\d\sA-Z]+)\))?(?:\s*-\s*(\d+h\s*\d*m?|\d+m))?$/;
  const matches = text.match(regex);

  // Si hay coincidencias, devolvemos cada parte encontrada
  if (matches) {
    return {
      name: matches[1].trim(),                     // Nombre
      price: matches[2] ? matches[2].trim() : '',  // Precio (si existe)
      duration: matches[3] ? matches[3].trim() : ''// Duración (si existe)
    };
  }

  // Si no hay coincidencias, devolvemos solo el nombre
  return {
    name: text.trim(),
    price: '',
    duration: ''
  };
}

const isMobile = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

const isIPhone = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Get the location of a postal code
async function fetchLocation(postalCode, country) {
  try {
    const response = await fetch("https://postcode-server.fly.dev/lookup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        country: country,
        postcode: postalCode
      })
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      // Handle error
      return null;
    }
  } catch (error) {
    // Handle error
    return null;
  }
}

// Check if some item close the conversation
const checkIfSomeItemCloseConversation = (items) => {
  return items.some((item) => {
    if (item.type === "select" || item.type === "selectAndPrice") {
      if (item.val) {
        const option = item.dataObject?.find((obj) => obj.value === item.val);
        return option?.closeConversation;
      }
    }
    if (item.type === "email" && item.filterDomain) {
      if (item.val) {
        let domain = item.val.split("@")[1];
        domain = domain.split(".")[0];
        if (domain === "gmail" || domain === "hotmail") {
          return true;
        }
      }
    }
    if (item.type === "zipcode") {
      if (checkZipCodeExclusions(item)) {
        return true;
      }
    }
    return false;
  });
}

const lightOrDark = (color) => {
  // Check the format of the color, HEX or RGB?
  let r, g, b
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
    )

    r = color[1]
    g = color[2]
    b = color[3]
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

    r = color >> 16
    g = (color >> 8) & 255
    b = color & 255
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 197.5) {
    return 'black'
  } else {
    return 'white'
  }
}

const trimUrlPeriod = (url) => {
  return url.endsWith('.') ? url.slice(0, -1) : url;
}

const addHttpsToUrl = (url) => {
  return url.startsWith('http') ? url : `https://${url}`;
}

const checkZipCodeExclusions = (item) => {
  let closeConversationMessage;
  item.dataObject?.forEach(ex => {
    let isPreffix = ex.value.endsWith('*');
    if (isPreffix) {
      // remove the * from the value
      let preffix = ex.value.slice(0, -1);
      // check if the value starts with the preffix
      if (item.val.startsWith(preffix)) {
        closeConversationMessage = ex.closeConversationMessage;
      }
    } else {
      if (item.val === ex.value) {
        closeConversationMessage = ex.closeConversationMessage;
      }
    }
  });
  return closeConversationMessage;
}

export { showOnlyOnce, getHue, padValue, getproperty, toArray, getWrittenName, splitNameAndPrice, isMobile, isIPhone, lightOrDark, fetchLocation, checkIfSomeItemCloseConversation, trimUrlPeriod, addHttpsToUrl, checkZipCodeExclusions };
